import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class AircraftLogbooksIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronaves/diarios', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/aeronave/diario/editar/' + cell;
    
    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm button-inline'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        <button className="btn btn-sm btn-danger button-inline" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse diário de bordo?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/diario/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de diários de bordo</h3>
      <Link to="/aeronave/diario/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> <span className="hidden-sm hidden-xs">Adicionar diário de bordo</span></Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há diários de bordo cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="aircraft_registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>Matrícula</TableHeaderColumn>

        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>Data</TableHeaderColumn>

        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>Status</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='80'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftLogbooksIndex;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbooksIndex.js